import { injectable } from 'inversify';
import { DslRuntimeModule, moduleImplementation, RuntimeValue,
         runtimeValue, param, StringType, QuizType } from '@xlearn/common';

@injectable()
export class QuizDslRuntimeModule implements DslRuntimeModule {
  public readonly ns = 'quiz';

  get implementations() {
    return [
      moduleImplementation('object_reference', (params) => this.quizObjectReference(params), param(StringType)),
    ];
  }

  private quizObjectReference(params: RuntimeValue[]): RuntimeValue {
    const id = params[0].value;

    return runtimeValue({ id } as QuizReference, QuizType);
  }
}

export interface QuizReference {
  id: string;
}
